import React from 'react';

const VisitorAccessAppointmentFrontDeskList = React.lazy(() => {
  return import('./components/VisitorAccessAppointmentFrontDeskList');
});

const VisitorAccessAppointmentFrontDesk = () => (
  <React.Suspense
    fallback={
      <div style={{ fontSize: '36px', color: '#1f2d49' }}>Loading...</div>
    }
  >
    <VisitorAccessAppointmentFrontDeskList />
  </React.Suspense>
);

export default VisitorAccessAppointmentFrontDesk;
